import { useCallback } from "react"
import { useSearchParams } from "react-router-dom"

export const useBrandSearchParam = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const selectedBrandId = searchParams.get("brand_id") ?? ""

  const setSelectedBrandId = useCallback(
    (id: string) => {
      setSearchParams(prev => {
        const next = new URLSearchParams(prev)
        if (id) next.set("brand_id", id)
        else next.delete("brand_id")
        return next
      })
    },
    [setSearchParams]
  )

  return [selectedBrandId, setSelectedBrandId] as const
}
